import {Component, Vue} from 'vue-property-decorator';

@Component
export default class AppDrawerMixin extends Vue {
  get drawer() {
    return this.$store.getters.drawer;
  }

  set drawer(val: boolean) {
    this.$store.commit('setDrawer', val);
  }

  get clipped() {
    return this.$store.getters.clipped;
  }

  set clipped(val: boolean) {
    this.$store.commit('setClipped', val);
  }

  toggleDrawer() {
    this.drawer = !this.drawer;
  }
}
